// test371
(371 && 0);
